import { render, staticRenderFns } from "./StrategySystem.vue?vue&type=template&id=06c4f270&scoped=true"
import script from "./StrategySystem.vue?vue&type=script&lang=js"
export * from "./StrategySystem.vue?vue&type=script&lang=js"
import style0 from "./StrategySystem.vue?vue&type=style&index=0&id=06c4f270&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c4f270",
  null
  
)

export default component.exports